"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# RegisterSVG
An SVG Register icon
 */
var RegisterSVG = function RegisterSVG(_ref) {
  var color = _ref.color,
      height = _ref.height,
      width = _ref.width;
  return _react2.default.createElement(
    "svg",
    {
      "aria-label": "Register",
      role: "img",
      height: height || undefined,
      width: width || undefined,
      viewBox: "0 0 576 512",
      xmlns: "http://www.w3.org/2000/svg"
    },
    _react2.default.createElement(
      "g",
      { id: "register", fill: color, fillRule: "nonzero" },
      _react2.default.createElement("path", { d: "M387.5,337.6l40-40c7.6-7.5,20.5-2.2,20.5,8.5v157.8c0,26.5-21.5,48-48,48H48c-26.5,0-48-21.5-48-48V112 c0-26.5,21.5-48,48-48h285.8c10.7,0,16.1,12.9,8.5,20.5l-40,40c-2.3,2.2-5.3,3.5-8.5,3.5H64v320h320V346.1 C384,342.9,385.3,339.9,387.5,337.6z" }),
      _react2.default.createElement("path", { d: "M492.8,173.4c3.8,3.8,3.8,10,0,13.8L274.4,405.5l-92.8,10.3c-12.4,1.4-22.9-9.1-21.5-21.5 l10.3-92.8L388.8,83.2c3.8-3.8,10-3.8,13.8,0L492.8,173.4z" }),
      _react2.default.createElement("path", { d: "M564.6,115.5l-35.4,35.4c-3.8,3.8-10,3.8-13.8,0l-90.2-90.2 c-3.8-3.8-3.8-10,0-13.8l35.4-35.4c15.3-15.2,40-15.2,55.2,0l48.8,48.8C579.8,75.5,579.8,100.2,564.6,115.5z" })
    )
  );
};

RegisterSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

RegisterSVG.defaultProps = {
  color: undefined,
  height: undefined,
  width: undefined
};

RegisterSVG.displayName = "RegisterSVG";

exports.default = RegisterSVG;
RegisterSVG.__docgenInfo = {
  "description": "# RegisterSVG\r\nAn SVG Register icon",
  "methods": [],
  "displayName": "RegisterSVG",
  "props": {
    "color": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "a color for the icon"
    },
    "height": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "height for the SVG. Can be px, rem, percentage, etc."
    },
    "width": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "width for the SVG. Can be px, rem, percentage, etc."
    }
  }
};